export default __webpack_public_path__ + "static/media/circle-grey.1e3ea0c9.svg";